import { Close, Pointer } from '../icons';

export const LocationButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<button
			className='geolocation-btn wp-block-button'
			aria-label='Use My Location'
			onClick={() => {
				if (onClick) onClick();
			}}
		>
			<Pointer />
			Use My Location
		</button>
	);
};

export const CloseButton = () => {
	return (
		<button
			className='close-btn'
			aria-label='Close popup'
			onClick={() => {
				// @ts-ignore
				jQuery('#find-location').removeClass('active');
			}}
		>
			<Close />
		</button>
	);
};
